import { useEffect, useState } from 'react'

export const useNetwork = (): boolean => {
  const [isOnline, setIsOnline] = useState(typeof window !== 'undefined' ? window.navigator.onLine : true)

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const updateNetworkStatus = () => setIsOnline(window.navigator.onLine)
    window.addEventListener('online', updateNetworkStatus)
    window.addEventListener('offline', updateNetworkStatus)
    return () => {
      window.removeEventListener('online', updateNetworkStatus)
      window.removeEventListener('offline', updateNetworkStatus)
    }
  }, [])

  return isOnline
}
